import React from 'react';
import Tile from './Tile.js'

export default class SelectedTile extends React.Component {
  render() {
    return(
      <div className="selected-tile">
        <h3>
          Selection:
        </h3>
        <Tile image={this.props.image} orientation={this.props.orientation} />
      </div>
    );
  }
}